import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { IProductConfigurableSelection } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { NICmsContentField } from '@icms/core/content';
import { NBuilderConfig } from '../builder.config';
export namespace NBuilderProductsSetup {
    export const SECTION_OPTION_ATTR_ID = 'outfit_builder_section';

    export interface IStorageData {
        currentSectionOptionId?: number;
        selection?: ISelection;
        history?: {
            prevSelectedSection?: number;
        };
    }

    export interface ISelection {
        [sectionOptionId: number]: {
            configurableSelection: IProductConfigurableSelection;
            productId: number;
            matchedProductId: number;
            productType?: string;
        };
    }
    export interface ILeftSectionElement {
        sectionOption: number;
        iconImage: string;
        filterAttr: string[];
        listingTitle?: string;
        focusLeftPosition?: number;
        focusTopPosition?: number;
        focusScale?: number;
        focusLeftPositionForSingle?: number;
        focusTopPositionForSingle?: number;
        focusScaleForSingle?: number;
        useAdditionalLabel?: boolean;
        displayAdditionalImage?: boolean;
        hideForAttrOption?: number;
    }
    export interface IProductsSetupData {
        additionalHorseStepImage?: string;
        backgroundImage?: string;
        categoryId?: number;
    }
    export interface IOptionElementData extends ILeftSectionElement {
        listing?: ProductListing;
        selecetion?: string;
    }
    export interface IAdditionalHorseStep {
        id: number;
        title: string;
        image: string;
        options: NBuilderConfig.ISetupElementData[];
        squareVariant?: boolean;
    }
    export const ADDITIONAL_HORSE_SETP_ID = -1;
    export const setupElementFields: NICmsContentField.IField[] = [
        {
            key: 'name',
            type: NICmsContentField.EFieldType.text,
            title: 'Name',
            description: 'Name of option have to be uniq cause it is use as identifier of option',
            required: true
        },
        {
            key: 'image',
            title: 'Image',
            type: NICmsContentField.EFieldType.image,
            required: true,
            default: '/cms/media/default.png'
        },
        {
            key: 'preselect',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Preselect',
            default: false
        }
    ];
    const ATTRIBIUTES_OPTIONS = () =>
        ((window['app'] as App).resources.attribute as AttributeResource).getAllExisting().map(i => ({ key: i.id, title: i.data?.label }));
    export const leftSectionElementFields: NICmsContentField.IField[] = [
        <NICmsContentField.IChoiceField>{
            key: 'sectionOption',
            type: NICmsContentField.EFieldType.choice,
            title: 'Builder section option',
            required: true,
            options: () =>
                ((window['app'] as App).resources.attribute as AttributeResource)
                    ?.getExisting(SECTION_OPTION_ATTR_ID)
                    ?.data?.options?.map(i => ({ key: i.value, title: i.label }))
        },
        {
            key: 'iconImage',
            title: 'Icon image',
            type: NICmsContentField.EFieldType.image,
            required: true,
            default: '/cms/media/default.png'
        },
        <NICmsContentField.IChoiceField>{
            key: 'filterAttr',
            type: NICmsContentField.EFieldType.choice,
            title: 'Attribiutes for filter',
            required: true,
            multiple: true,
            options: ATTRIBIUTES_OPTIONS
        },
        <NICmsContentField.IToggleField>{
            key: 'useAdditionalLabel',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Use additional label for product image',
            default: false,
            labels: { true: 'Image with `Outfit builder additional`', false: 'Image with `Outfit builder image`' }
        },
        <NICmsContentField.IToggleField>{
            key: 'displayAdditionalImage',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Use additional image when this option have selection',
            default: false,
            labels: { true: 'Use additional image', false: 'Use usual image' }
        },
        <NICmsContentField.IChoiceField>{
            key: 'hideForAttrOption',
            type: NICmsContentField.EFieldType.choice,
            title: 'Hide image for attribute option',
            options: () =>
                ((window['app'] as App).resources.attribute as AttributeResource)
                    .getExisting(SECTION_OPTION_ATTR_ID)
                    ?.data?.options?.map(i => ({ key: i.value, title: i.label }))
        },
        {
            key: 'listingTitle',
            type: NICmsContentField.EFieldType.text,
            title: 'Listing title'
        }
    ];

    export const focusPositionFields = [
        {
            key: 'focusLable',
            title: 'Focus positions for main view',
            type: NICmsContentField.EFieldType.label
        },
        <NICmsContentField.INumberField>{
            key: 'focusScale',
            type: NICmsContentField.EFieldType.number,
            title: 'Focus scale',
            description: 'Default focus scale is 2',
            default: 2,
            min: 1.25,
            max: 3
        },
        <NICmsContentField.INumberField>{
            key: 'focusTopPosition',
            type: NICmsContentField.EFieldType.number,
            title: 'Focus top position in %',
            min: 0,
            max: 100
        },
        <NICmsContentField.INumberField>{
            key: 'focusLeftPosition',
            type: NICmsContentField.EFieldType.number,
            title: 'Focus left position in %',
            min: 0,
            max: 100
        },

        {
            key: 'focusSingleLable',
            title: 'Focus positions for single option view',
            type: NICmsContentField.EFieldType.label
        },
        <NICmsContentField.INumberField>{
            key: 'focusScaleForSingle',
            type: NICmsContentField.EFieldType.number,
            title: 'Focus scale for single view',
            description: 'Default focus scale is 2',
            default: 2,
            min: 1.25,
            max: 3
        },
        <NICmsContentField.INumberField>{
            key: 'focusTopPositionForSingle',
            type: NICmsContentField.EFieldType.number,
            title: 'Focus top for single view',
            min: 0,
            max: 100
        },
        <NICmsContentField.INumberField>{
            key: 'focusLeftPositionForSingle',
            type: NICmsContentField.EFieldType.number,
            title: 'Focus left for single view',
            min: 0,
            max: 100
        }
    ];

    export const productsSetupFields = [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'configuration-step',
            title: 'Products configuration step',
            tab: 'Builder General Setup'
        },
        {
            key: 'typeData.backgroundImage',
            title: 'Background configuration image',
            type: NICmsContentField.EFieldType.image,
            tab: 'Builder General Setup'
        },
        {
            key: 'typeData.categoryId',
            title: 'Category id',
            type: NICmsContentField.EFieldType.number,
            tab: 'Builder General Setup'
        },
        {
            key: 'typeData.additionalHorseStepImage',
            title: 'Additional horse step image',
            type: NICmsContentField.EFieldType.image,
            tab: 'Builder General Setup',
            description: 'Without this image additional step in product setup will not be shown'
        }
    ];
}
